import { render, staticRenderFns } from "./CategoriaResumen.vue?vue&type=template&id=709b67c6&scoped=true&"
import script from "./CategoriaResumen.vue?vue&type=script&lang=js&"
export * from "./CategoriaResumen.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaResumen.vue?vue&type=style&index=0&id=709b67c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b67c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VSimpleTable})
